import mixpanel from 'mixpanel-browser';

export class MPtracking {
  private static kMixpanelTokenId = '7f5cd212660fa0bc40eb2cd1335ede5c';

  // ---------------------------------------------------------------------------
  public static init() {
    // mixpanel.init(this.kMixpanelTokenId);
  }

  // ---------------------------------------------------------------------------
  public static track(
    name: string,
    properties: object,
    options: object = null,
  ) {
    // mixpanel.track(name, properties, options);
  }
}
